package com.example.mystybag.database.communication.db

import app.cash.sqldelight.db.SqlDriver
import com.example.mystybag.database.communication.db.daos.ContactLinksDao
import com.example.mystybag.database.communication.db.daos.EmbeddingsDao
import example.mystybag.db.MystyBagRoomDatabase

@Suppress("VARIABLE_IN_SINGLETON_WITHOUT_THREAD_LOCAL")
object DatabaseProvider {
    private var driver                  : SqlDriver?                   = null
    private var database                : MystyBagRoomDatabase?         = null

    private var contactLinksDao         : ContactLinksDao?           = null
    private var embeddingsDao          : EmbeddingsDao?              = null
    
    fun initDatabase(driverFactory: DatabaseDriverFactory) : MystyBagRoomDatabase? {
        if(database == null) {
            driver                    = driverFactory.createDriver()
            database                  = MystyBagRoomDatabase(driver!!)
            contactLinksDao           = ContactLinksDao()
            embeddingsDao             = EmbeddingsDao()
        }

        return database
    }

    /**
     * Прилага схемата (CREATE TABLE и индекси) в worker-а. Задължително за Web – иначе таблиците не съществуват.
     */
    suspend fun runSchema() {
        val d = driver ?: return
        // Изпълняваме същата схема като MystyBagRoomDatabase.Schema.create (async driver изисква .await())
        d.execute(null, """
            CREATE TABLE IF NOT EXISTS contact_image_links (
                wallet_id   INTEGER PRIMARY KEY NOT NULL,
                contact_id  TEXT,
                link        TEXT,
                name        TEXT,
                name_search TEXT,
                last_ts     INTEGER NOT NULL DEFAULT 0
            )
        """.trimMargin(), 0).await()
        d.execute(null, """
            CREATE TABLE IF NOT EXISTS embeddings (
                merchantLocationId INTEGER NOT NULL,
                cityId INTEGER NOT NULL,
                lang TEXT NOT NULL,
                docType TEXT NOT NULL,
                qScale REAL NOT NULL,
                qZeroPoint INTEGER NOT NULL,
                vecQint8 BLOB NOT NULL,
                lastModifiedIso TEXT NOT NULL DEFAULT '',
                PRIMARY KEY (merchantLocationId, docType)
            )
        """.trimMargin(), 0).await()
        d.execute(null, "CREATE INDEX IF NOT EXISTS contact_links_id_index ON contact_image_links (contact_id)", 0).await()
        d.execute(null, "CREATE INDEX IF NOT EXISTS embeddings_cityId_idx ON embeddings(cityId)", 0).await()
        d.execute(null, "CREATE INDEX IF NOT EXISTS embeddings_lang_idx ON embeddings(lang)", 0).await()
        d.execute(null, "CREATE INDEX IF NOT EXISTS embeddings_docType_idx ON embeddings(docType)", 0).await()
        d.execute(null, "CREATE INDEX IF NOT EXISTS embeddings_city_docType_idx ON embeddings(cityId, docType)", 0).await()
    }

    fun getDatabaseInstance()       : MystyBagRoomDatabase?        = database

    fun getContactLinksDao()        : ContactLinksDao?          = contactLinksDao

    fun getEmbeddingsDao()         : EmbeddingsDao?             = embeddingsDao

    fun clearDatabase() {
    }
}
